import type { ReactElement } from 'react'

import { trackMxEvent } from '@/utils/mixpanel'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

const FAQ = [
  {
    title: 'どんな依頼がありますか？',
    description: 'アーティストやアイドルのオリジナル曲や、ゲームやイベントのBGM、レコーディングやライブのサポートなど、様々なクライアントからの様々なご依頼があります。',
  },
  {
    title: 'どんなクリエイターが登録していますか？',
    description: '事務所と業務提携をしている方、完全フリーの方、歌ものが得意な方、BGM専門に受けている方、など、様々なスキルを持ったクリエイターが集まっています。',
  },
  {
    title: '登録料はかかりますか？',
    description: '登録料・更新料は一切かかりません。お仕事の窓口のひとつとして、お気軽にご登録ください。',
  },
  {
    title: '手数料はどのくらいですか？',
    description: 'サービスご利用手数料として、報酬の20%をいただいております。',
  },
  {
    title: '価格の制限はありますか？',
    description: '提供するサービスに関して、価格や内容はお好きに決めていただくことができます。価格を非公開にすることも可能です。',
  },
  {
    title: '誰でもクリエイターとして登録できますか？',
    description: 'ご登録の前に、運営による審査がございます。過去のご経歴やご実績をご用意の上、申請をお願いいたします。',
  },
  {
    title: '依頼を断ることはできますか？',
    description: 'クライアントとの条件が合わなかった場合には依頼をお断りすることも可能ですし、忙しい時期にはステータスを「問い合わせ停止」にすることも可能です。（支払い前に限る）',
  },
]

const ForProFAQ = (): ReactElement | null => {

  return (
    <div className="container">
      <h2 className="mb-8 text-center text-3xl font-bold">よくある質問</h2>
      <div className="flex justify-center">
        <Accordion type="single" collapsible className="w-full max-w-4xl">
          {FAQ.map((qa, i) => (
            <AccordionItem key={qa.title} value={`faq-${i}`}>
              <AccordionTrigger
                className="py-5 text-base hover:no-underline"
                onClick={() =>
                  trackMxEvent('Service Faq Click', {
                    faq: qa.title,
                  })
                }
              >
                {qa.title}
              </AccordionTrigger>
              <AccordionContent className="text-ghost text-sm md:text-base">
                {qa.description}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  )
}

export default ForProFAQ
